import { useCallback, useSyncExternalStore } from 'react';

// `useSyncExternalStore` since `Date.now()` in render would desync components (react-hooks/purity)
// and setState-in-effect would cascade a render on mount; quantised to whole seconds so getSnapshot stays stable between calls.

const SNAPSHOT_RESOLUTION_MS = 1000;
const DEFAULT_TICK_MS = 15_000;

const getSnapshot = (): number =>
  Math.floor(Date.now() / SNAPSHOT_RESOLUTION_MS) * SNAPSHOT_RESOLUTION_MS;

/** No clock during SSR; `formatRelativeTime` renders 0 as "just now". */
const getServerSnapshot = (): number => 0;

// `tickMs` controls display refresh, not accuracy — a countdown wants 1s, a "minutes ago" label
// is fine at the default. Memoised since useSyncExternalStore re-subscribes on identity change.
export const useNow = (tickMs: number = DEFAULT_TICK_MS): number => {
  const subscribe = useCallback(
    (onStoreChange: () => void): (() => void) => {
      const timer = setInterval(onStoreChange, tickMs);
      return (): void => {
        clearInterval(timer);
      };
    },
    [tickMs],
  );

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
